import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddMedicationsInUseComponent } from '../dialogs/medications-in-use/add-medications-in-use/add-medications-in-use.component';
import { Medication } from 'src/app/features/medical-record/medical-record-page/pages/chemotherapy/model/medications.model';

export class PharmacyMedications {
  medicamento: string = '';
  via: string = '';
  observacao: string = '';
}

@Component({
  selector: 'app-selected-medications-in-use',
  templateUrl: './selected-medications-in-use.component.html',
  styleUrls: ['./selected-medications-in-use.component.scss']
})
export class SelectedMedicationsInUseComponent {

  panelExpanded: boolean = true;
  @Input() width: string = '809px';
  @Input() height: string = '95px';
  @Input() title: string = 'Medicamentos em uso';

  @Input() arrayItems: Array<any> = [];
  @Input() isAddingOrEditing: string = 'adding';
  @Input() isFirstQuestionnaire: boolean = false;
  @Input() isConditionFilled: boolean = false;

  @Output() addOrEditButton = new EventEmitter();
  @Output() onMedsChanges = new EventEmitter();

  medications: Array<PharmacyMedications> = [];

  constructor(
    private dialog: MatDialog,
  ) {
  }

  showTitle(category: any) {
    if (this.arrayItems.length > 0) {
      if (category.allergyCategory.answer[0] !== '' && category.allergyTypes.find((type: any) => type.answer[0] !== '')) {
        return category.allergyCategory.answer[0];
      }
    }
    return;
  }

  ngOnInit() {
    if (this.arrayItems.length > 0) {
      this.medications = [...this.arrayItems];
      this.isFirstQuestionnaire = false;
      this.isAddingOrEditing = 'editing';
    }
  }

  openDialog() {
    this.dialog.open(AddMedicationsInUseComponent, {
      minWidth: '1192px',
      disableClose: true,
      data: {
        medsInUse: this.medications
      }
    }).afterClosed()
      .subscribe((value) => {
        if (value && value.medicationsInUse && value.medicationsInUse.length > 0) {
          this.medications = value.medicationsInUse;
          this.onMedsChanges.emit(this.medications);
        }
      })
  }

  applyDesign() {
    return { width: this.width, display: 'grid' };
  }

}
